import { createAction, createActionGroup, emptyProps, props } from '@ngrx/store';
import { IProgressResponseItem, IProjectInfo } from '@shared/model/project';
import { IProjectConfig } from '@shared/model/projects';
import { IProjectLogo } from '@shared/model/projects';
import { IField } from '@shared/model/basic-data';

const projectActions = createActionGroup({
  source: 'Project',
  events: {
    'Get Project Info': props<{ id: number }>(),
    'Get Project Info Success': props<{ project: IProjectInfo & { id: number }; projectConfig: IProjectConfig }>(),
    'Get Project Info Failure': emptyProps(),
    'Get Project Navigation Progress': props<{ id: number }>(),
    'Get Project Navigation Progress Success': props<{ progress: IProgressResponseItem }>(),
    'Get Project Navigation Progress Failure': emptyProps(),
    'Change Project Info Field': props<{ id: number; data: any }>(),
    'Change Project Info Field Success': props<{ data: IField }>(),
    'Change Project Info Field Failure': emptyProps(),
  },
});

export const {
  getProjectInfo,
  getProjectInfoSuccess,
  getProjectInfoFailure,
  getProjectNavigationProgress: getProgress,
  getProjectNavigationProgressSuccess: getProgressSuccsess,
  getProjectNavigationProgressFailure: getProgressFailure,
  changeProjectInfoField,
  changeProjectInfoFieldSuccess,
  changeProjectInfoFieldFailure,
} = projectActions;

export enum ProjectActionTypes {
  NAV_BUTTON_CLICK = '[Project] Navigation button click',
  CALC_BUTTON_CLICK = '[Project] Calculation button click',
  SET_CALCULATION_ID = '[Project] Set Calculation Id',
}

export const navBtnClick = createAction(ProjectActionTypes.NAV_BUTTON_CLICK);
export const calcBtnClick = createAction(ProjectActionTypes.CALC_BUTTON_CLICK, props<{ calc_id: number | null }>());
export const setCalculationId = createAction(ProjectActionTypes.SET_CALCULATION_ID, props<{ calc_id: number | null }>());

const projectLogoFileActions = createActionGroup({
  source: 'Project',
  events: {
    'Upload Project Logo File': props<{ id: number; file: File; file_type: string }>(),
    'Upload Project Logo File Success': props<{ file: IProjectLogo }>(),
    'Upload Project Logo File Failure': emptyProps(),
    'Delete Project Logo File': props<{ id: number }>(),
    'Delete Project Logo File Success': props<{ id: number }>(),
    'Delete Project Logo File Failure': emptyProps(),
  },
});

export const {
  uploadProjectLogoFile,
  uploadProjectLogoFileSuccess,
  uploadProjectLogoFileFailure,
  deleteProjectLogoFile,
  deleteProjectLogoFileSuccess,
  deleteProjectLogoFileFailure,
} = projectLogoFileActions;
